var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPressureIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33582 5.66418C5.66914 5.99751 6.20958 5.99751 6.54291 5.66418C6.87624 5.33086 7.75 3.25 7.75 3.25C7.75 3.25 5.66914 4.12376 5.33582 4.45709C5.00249 4.79042 5.00249 5.33086 5.33582 5.66418Z",
    fill: "#BB032A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C3.79086 1 2 2.79086 2 5C2 6.86384 3.27477 8.42994 5 8.87398V10H1.25C1.11193 10 1 10.1119 1 10.25V11.25C1 11.3881 1.11193 11.5 1.25 11.5H10.75C10.8881 11.5 11 11.3881 11 11.25V10.25C11 10.1119 10.8881 10 10.75 10H7V8.87398C8.72523 8.42994 10 6.86384 10 5C10 2.79086 8.20914 1 6 1ZM3 5C3 3.34315 4.34315 2 6 2C7.65685 2 9 3.34315 9 5C9 6.65685 7.65685 8 6 8C4.34315 8 3 6.65685 3 5Z",
    fill: "#BB032A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C8.20914 9 10 7.20914 10 5C10 2.79086 8.20914 1 6 1C3.79086 1 2 2.79086 2 5C2 7.20914 3.79086 9 6 9ZM6 9.5C8.48528 9.5 10.5 7.48528 10.5 5C10.5 2.51472 8.48528 0.5 6 0.5C3.51472 0.5 1.5 2.51472 1.5 5C1.5 7.48528 3.51472 9.5 6 9.5Z",
    fill: "#BB032A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressureIcon);
export default __webpack_public_path__ + "static/media/pressureIcon.bcdfa53c841620b1b444ba1311223526.svg";
export { ForwardRef as ReactComponent };